import { FelaCSS, FelaCSSWithCustomSelectors } from '../../../../components/fela/flowtypes';
import { colors, spacing } from '../../../../themes/variables';
import { SharedTypes as PropTypes } from './radio-toggle-v2';

interface StyleTypes {
  wrapper: FelaCSS;
  iconWrap: FelaCSSWithCustomSelectors;
  label: FelaCSS;
}

const styles = ({ checked, disabled }: PropTypes): StyleTypes => {
  const wrapperDisabled: FelaCSS = disabled
    ? {
        pointerEvents: 'none',
        cursor: 'default',
        color: colors.space15,
        borderColor: colors.space15,
      }
    : {
        color: colors.space,
        cursor: 'pointer',
      };

  return {
    wrapper: {
      ...wrapperDisabled,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      paddingLeft: spacing[2],
      paddingRight: spacing[2],
      height: '34px',
      fontDefaultSemiBold: 14,
      lineHeight: '14px',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderRadius: '12px',
      borderColor: checked ? colors.indigoCrush : colors.space15,
      boxSizing: 'border-box',
      backgroundColor: checked ? colors.indigoCrush04 : colors.white,
    },

    iconWrap: {
      justifyContent: 'center',
      marginRight: spacing[1],
    },
    label: {
      fontDefault: 14,
    },
  };
};

export default styles;
